var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"alert alert-danger\" id=\"help-msg\">");t.b("\n" + i);t.b("    <p data-i18n=\"traces.searchDisabled\">Searching has been disabled via the searchEnabled property.</p>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"alert alert-danger\" id=\"help-msg\">\n    <p data-i18n=\"traces.searchDisabled\">Searching has been disabled via the searchEnabled property.</p>\n</div>\n", H);return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./templates/searchDisabled.mustache
// module id = 164
// module chunks = 0